import { render } from "./myPoint.vue?vue&type=template&id=f03b1c9e"
import script from "./myPoint.vue?vue&type=script&lang=js"
export * from "./myPoint.vue?vue&type=script&lang=js"

import "./myPoint.vue?vue&type=style&index=0&id=f03b1c9e&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__